var exports = {
  "wx": "header__ZqTG4W",
  "my": "avatar__vZBxk9",
  "DD": "title__ILmPO_",
  "_N": "smallTitle__DBbjgL",
};

module.exports = exports;
